import React, { PureComponent, PropTypes } from 'react';
import { isBlank } from 'underscore.string';
import CityProvincePostal from './CityProvincePostal';

const notBlank = s => !isBlank(s);

export default class FormattedAddress extends PureComponent {
  static propTypes = {
    address: PropTypes.shape({
      address1: PropTypes.string,
      address2: PropTypes.string,
      city: PropTypes.string,
      province: PropTypes.string,
      postalCode: PropTypes.string,
    }).isRequired,

    componentSeparator: PropTypes.node
  };

  static defaultProps = {
    componentSeparator: <br/>
  };

  render() {
    const { address, className, componentSeparator } = this.props;

    const { address1, address2, city, province, postalCode } = address;

    const components = _.compact(
      [
        notBlank(address1) ? address1 : null,
        notBlank(address2) ? address2 : null,
        (notBlank(city) || notBlank(province) || notBlank(postalCode)) ?
          <CityProvincePostal city={city} province={province} postalCode={postalCode}/> : null
      ]
    );

    return (
      <span className={className}>
        {
          _.map(components, (c, ix) =>
            (
              <span key={ix}>
                {c}{ix < components.length - 1 ? componentSeparator : null}
              </span>
            )
          )
        }
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/FormattedAddress.jsx